import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { locationMasters } from "../../redux/actions/grievanceActions1";

const ViewEvent = ({ onClose, show, eventDetails }) => {
  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(locationMasters());
  }, [dispatch]);
  
  const { locationMaster } = useSelector((state) => state.grievances);

  // Format time to a readable format
  const formatTime = (timeString) => {
    if (!timeString) return "";

    try {
      // If time is in HH:MM:SS format
      const [hours, minutes] = timeString.split(":");
      const timeDate = new Date();
      timeDate.setHours(parseInt(hours, 10));
      timeDate.setMinutes(parseInt(minutes, 10));

      return timeDate.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } catch (error) {
      return timeString;
    }
  };

  // Get location name from location_id
  const getLocationName = (locationId) => {
    if (!locationMaster || !locationId) return "";
    const location = locationMaster.find(loc => loc.location_id == locationId);
    return location ? location.location_name : "";
  };

  const handleClose = () => {
    onClose();
  };

  if (!show || !eventDetails) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0, 0, 0, 0.5)" }}
      tabIndex={-1}
      role="dialog"
      aria-labelledby="ViewEventModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div style={{ backgroundColor: "#fff" }} className="modal-content">
          <div className="modal-header">
            <h5
              className="modal-title font-size-16"
              id="viewEvent-exampleModalLabel"
            >
              View Event Details
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
            ></button>
          </div>
          <div className="modal-body p-4">
            {/* Event ID Display */}
            {eventDetails?.event_id && (
              <div className="mb-3">
                <small className="text-muted">
                  Event ID: <strong>{eventDetails.event_id}</strong>
                </small>
              </div>
            )}

            {/* Event Title */}
            <div className="mb-3">
              <label htmlFor="event-title" className="form-label fw-bold">
                Event Title
              </label>
              <input
                type="text"
                className="form-control bg-light"
                id="event-title"
                value={eventDetails.title || ""}
                readOnly
                disabled
              />
            </div>

            {/* Event Date */}
            <div className="mb-3">
              <label htmlFor="event-date" className="form-label fw-bold">
                Event Date
              </label>
              <input
                type="text"
                className="form-control bg-light"
                id="event-date"
                value={eventDetails.event_date || ""}
                readOnly
                disabled
              />
            </div>

            {/* Time Fields */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="event-from-time" className="form-label fw-bold">
                  Start Time
                </label>
                <input
                  type="text"
                  className="form-control bg-light"
                  id="event-from-time"
                  value={formatTime(eventDetails.event_from_time) || ""}
                  readOnly
                  disabled
                />
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="event-to-time" className="form-label fw-bold">
                  End Time
                </label>
                <input
                  type="text"
                  className="form-control bg-light"
                  id="event-to-time"
                  value={formatTime(eventDetails.event_to_time) || ""}
                  readOnly
                  disabled
                />
              </div>
            </div>

            {/* Location */}
            <div className="mb-3">
              <label htmlFor="event-location" className="form-label fw-bold">
                Location
              </label>
              <input
                type="text"
                className="form-control bg-light"
                id="event-location"
                value={getLocationName(eventDetails.location_id) || eventDetails.location_name || ""}
                readOnly
                disabled
              />
            </div>

            {/* Event Description */}
            <div className="mb-3">
              <label htmlFor="event-desc" className="form-label fw-bold">
                Event Description
              </label>
              <textarea
                className="form-control bg-light"
                id="event-desc"
                rows="3"
                value={eventDetails.event_desc || ""}
                readOnly
                disabled
              ></textarea>
            </div>

            {/* Important Guests */}
            <div className="mb-3">
              <label htmlFor="important-guests" className="form-label fw-bold">
                Important Guests
              </label>
              <textarea
                className="form-control bg-light"
                id="important-guests"
                rows="2"
                value={eventDetails.important_guests || ""}
                readOnly
                disabled
              ></textarea>
            </div>

            {/* Event URL */}
            <div className="mb-3">
              <label htmlFor="event-url" className="form-label fw-bold">
                Event URL
              </label>
              <input
                type="text"
                className="form-control bg-light"
                id="event-url"
                value={eventDetails.event_url || ""}
                readOnly
                disabled
              />
              {eventDetails.event_url && (
                <div className="mt-2">
                  <a
                    href={eventDetails.event_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-outline-primary"
                  >
                    <i className="bi bi-box-arrow-up-right me-1"></i>
                    Open Event Link
                  </a>
                </div>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewEvent; 